import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { widgetErrorSx } from '../utils/styles.ts';
import { getWidgetNotices } from '../utils/widgetNotices.ts';

export const OpenXAgentWidgetError = () => {
  const { t } = useTranslation();

  return (
    <Typography variant="body2" sx={widgetErrorSx} data-test="openx-agent-widget-error">
      {getWidgetNotices(t).errorNotice}
    </Typography>
  );
};
